import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "../../store/state/app.state";
import { IStep } from "../../data-types/steps.interface";
import { EButtonType } from "../../data-types/button.enum";
import { CustomValidatorsService } from "../../services/custom-validators.service";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { FormGroup } from "@angular/forms";
import { CoworkingService } from "../../services/coworking.service";
import { Coworking } from "../../data-types/coworking.interface";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { showAlertAction } from "../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
import { CowingSecurityEncryptService } from "../../services/cowingSecurityEncrypt.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";
import { CompanyService } from "../../services/company.service";
import { Company } from "../../data-types/company.interface";

@Component({
  selector: "cowing-core-company-plus-funnel",
  templateUrl: "./company-plus-funnel.component.html",
  styleUrls: ["./company-plus-funnel.component.scss"],
})
export class CompanyPlusFunnelComponent {
  private skipBankInfo: boolean = false;
  private skipEmployees: boolean = false;
  constructor(
    private _store: Store<IAppState>,
    private formBuilder: FormBuilder,
    private router: Router,
    private translate: TranslateService,
    private customValidatorsService: CustomValidatorsService,
    private companyService: CompanyService,
    private coworkingService: CoworkingService,
    private securityService: CowingSecurityEncryptService
  ) {}
  public EButtonType = EButtonType;
  public steps: Array<IStep> = [
    {
      stepNumber: 1,
      isActive: true,
      title: "company.steps.general",
    },
    {
      stepNumber: 2,
      isActive: false,
      title: "company.steps.employees",
    },
    {
      stepNumber: 3,
      isActive: false,
      title: "coworking.steps.spaces",
    },
    {
      stepNumber: 4,
      isActive: false,
      title: "coworking.steps.services",
    },
    {
      stepNumber: 5,
      isActive: false,
      title: "company.steps.paymethods",
    },
    {
      stepNumber: 6,
      isActive: false,
      title: "company.steps.confirm",
    },
  ];
  public registerForm = this.formBuilder.group({
    generalForm: this.formBuilder.group({
      file: new FormControl(null),
      business_name: new FormControl(null, [Validators.required]),
      company_name: new FormControl(null, [Validators.required]),
      tax_id: new FormControl(null, [Validators.required]),
      fiscal_address: new FormControl(null, [Validators.required]),
      city: new FormControl(null, [Validators.required]),
      country: new FormControl(null, [Validators.required]),
      province: new FormControl(null, [Validators.required]),
      latitude: new FormControl(null, [Validators.required]),
      longitude: new FormControl(null, [Validators.required]),
      is_business_group: new FormControl("No", []),
      business_group: new FormControl({ value: null, disabled: true }, []),
      name: new FormControl(null, [Validators.required]),
      phone: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      is_coworking_too: true,

      schedule_open_1: new FormControl(null, [Validators.required]),
      schedule_open_2: new FormControl(null, [Validators.required]),
      schedule_open_3: new FormControl(null, [Validators.required]),
      schedule_open_4: new FormControl(null, [Validators.required]),
      schedule_open_5: new FormControl(null, [Validators.required]),
      schedule_open_6: new FormControl(null, [Validators.required]),
      schedule_open_7: new FormControl(null, [Validators.required]),
      schedule_close_1: new FormControl(null, [Validators.required]),
      schedule_close_2: new FormControl(null, [Validators.required]),
      schedule_close_3: new FormControl(null, [Validators.required]),
      schedule_close_4: new FormControl(null, [Validators.required]),
      schedule_close_5: new FormControl(null, [Validators.required]),
      schedule_close_6: new FormControl(null, [Validators.required]),
      schedule_close_7: new FormControl(null, [Validators.required]),
      video_1: new FormControl(null),
      photo_1: new FormControl(null, [Validators.required]),
      photo_2: new FormControl(null, [Validators.required]),
      photo_3: new FormControl(null, [Validators.required]),
      photo_4: new FormControl(null, [Validators.required]),
      photo_5: new FormControl(null, [Validators.required]),
      description: new FormControl(null, [
        Validators.required,
        Validators.maxLength(300),
      ]),
    }),
    employeesForm: this.formBuilder.array([]),
    spacesForm: this.formBuilder.array([
      new FormGroup({
        imagePath: new FormControl(null, [Validators.required]),
        name: new FormControl(null, [Validators.required]),
        spaceCategory: new FormControl(null, [Validators.required]),
        capacity: new FormControl(null, [Validators.required]),
        quantity: new FormControl(null, [Validators.required]),
        price_hour: new FormControl(null, [Validators.required]),
        price_day: new FormControl(null, [Validators.required]),
        price_week: new FormControl(null, [Validators.required]),
        price_month: new FormControl(null, [Validators.required]),
      }),
    ]),
    servicesForm: this.formBuilder.array([]),
    paymethodsForm: this.formBuilder.group({
      holderId: new FormControl(null, [Validators.required]),
      swift: new FormControl(null, [Validators.required]),
      IBAN: new FormControl(null, [
        Validators.required,
        this.customValidatorsService.validateIBAN,
      ]),
      address: new FormControl(null, [Validators.required]),
      city: new FormControl(null, [Validators.required]),
      country: new FormControl(null, [Validators.required]),
      province: new FormControl(null, [Validators.required]),
    }),
    cardForm: this.formBuilder.group({
      owner: new FormControl(null, [Validators.required]),
      cardNumber: new FormControl(null, [Validators.required]),
      expireDate: new FormControl(null, [Validators.required]),
      cvv: new FormControl(null, [
        Validators.required,
        Validators.maxLength(4),
      ]),
    }),
  });

  public formControl(controlname) {
    return this.registerForm.controls;
  }

  public skipBankInfoCompany() {
    this.skipBankInfo = true;
    this.setNextStep(6);
  }

  public skipEmployeesCompany() {
    this.skipEmployees = true;
    this.setNextStep(3);
  }

  private formGeneralInfoData() {
    const form = this.registerForm.get("generalForm").value;
    const formattedForm: any = new Company(form);
    formattedForm.email = this.registerForm
      .get("generalForm")
      .get("email").value;
    formattedForm.hours = [
      {
        day: 0,
        end: form.schedule_close_1,
        start: form.schedule_open_1,
      },
      {
        day: 1,
        end: form.schedule_close_2,
        start: form.schedule_open_2,
      },
      {
        day: 2,
        end: form.schedule_close_3,
        start: form.schedule_open_3,
      },
      {
        day: 3,
        end: form.schedule_close_4,
        start: form.schedule_open_4,
      },
      {
        day: 4,
        end: form.schedule_close_5,
        start: form.schedule_open_5,
      },
      {
        day: 5,
        end: form.schedule_close_6,
        start: form.schedule_open_6,
      },
      {
        day: 6,
        end: form.schedule_close_7,
        start: form.schedule_open_7,
      },
    ];
    return formattedForm;
  }

  private formServices() {
    const selectedServices: Array<any> = [];
    const servicesFormArray: any = this.registerForm.get('servicesForm');
    servicesFormArray.controls.forEach((serviceGroup) => {
      for (const service in serviceGroup.controls) {
        const anyService: any = serviceGroup.controls[service];
        selectedServices.push({
          id: anyService.rawValue.id,
          value: anyService.value,
        });
      }
    });
    return selectedServices;
  }

  private formMedia() {
    let mediaFormData: FormData = new FormData();

    if (this.registerForm.get("generalForm").get("video_1").value !== null) {
      mediaFormData.append(
        "video_1",
        this.registerForm.get("generalForm").get("video_1").value
      );
    }
    mediaFormData.append(
      "photo_1",
      this.registerForm.get("generalForm").get("photo_1").value
    );
    mediaFormData.append(
      "photo_2",
      this.registerForm.get("generalForm").get("photo_2").value
    );
    mediaFormData.append(
      "photo_3",
      this.registerForm.get("generalForm").get("photo_3").value
    );
    mediaFormData.append(
      "photo_4",
      this.registerForm.get("generalForm").get("photo_4").value
    );
    mediaFormData.append(
      "photo_5",
      this.registerForm.get("generalForm").get("photo_5").value
    );
    return mediaFormData;
  }

  private formBankData() {
    const validForm = this.registerForm.get("paymethodsForm").valid
      ? "paymethodsForm"
      : "cardForm";
    let encryptedData: string = this.securityService.encrypt(
      JSON.stringify(this.registerForm.get(`${validForm}`).value)
    );
    return encryptedData;
  }

  public async setNextStep(event) {
    if (this.whatStepIsActive === 6) {
      this._store.dispatch(showLoadingAction({}));
      try {
        const token = LocalStorageService.instance.get(EStorageType.Token);
        let companyInfo;
        if (token) {
          companyInfo = await this.companyService.createCompany(
            this.formGeneralInfoData()
          );
        } else {
          companyInfo = await this.companyService.createFirstCompany(
            this.formGeneralInfoData()
          );
        }

        const companyId = companyInfo.id;
        const coworkingId = companyInfo.coworking_id;

        // send new coworking media data
        await this.coworkingService.addMedias(
          this.formMedia(),
          coworkingId
        );

        // send data for every space
        for (let space of this.registerForm.get("spacesForm").value) {
          let newSpace = { ...space };
          newSpace.type_id = newSpace.spaceCategory.id;
          delete newSpace.spaceCategory;
          delete newSpace.imagePath;

          const spaceAdded = await this.coworkingService.addSpaces(
            newSpace,
            coworkingId
          );
          const spaceImageFormData = new FormData();
          spaceImageFormData.append("file", space.imagePath);
          const spaceImageAdded = await this.coworkingService.addSpaceImage(
            spaceImageFormData,
            spaceAdded.id
          );
        }

        // send data for every service
        await this.coworkingService.addServices(
          this.formServices(),
          coworkingId
        );

        if (!this.skipEmployees) {
          const employeesToCompany =
            await this.companyService.createEmployeesToCompany(
              this.registerForm.get("employeesForm").value,
              companyId
            );
        }
        if (!this.skipBankInfo) {
          // formBankData
          const formToCompany = await this.companyService.addBankInfo(
            this.formBankData(),
            companyId
          );
        }
        this.router.navigate(["landing"]);
      } catch (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                e.status === 401
                  ? this.translate.instant("general.expired")
                  : e.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      } finally {
        this._store.dispatch(closeLoadingAction({}));
      }
    } else {
      let activeStep = this.whatStepIsActive + 1;
      this.setNewNextStep(activeStep);
    }
  }

  public setLocationPaymethod(location) {
    this.registerForm.get("paymethodsForm").get("city").setValue(location.city);
    this.registerForm
      .get("paymethodsForm")
      .get("country")
      .setValue(location.country);
    this.registerForm
      .get("paymethodsForm")
      .get("province")
      .setValue(location.province);
  }

  public setLocation(location) {
    this.registerForm.get("generalForm").get("latitude").setValue(location.lat);
    this.registerForm
      .get("generalForm")
      .get("longitude")
      .setValue(location.lng);
    this.registerForm.get("generalForm").get("city").setValue(location.city);
    this.registerForm
      .get("generalForm")
      .get("country")
      .setValue(location.country);
    this.registerForm
      .get("generalForm")
      .get("province")
      .setValue(location.province);
  }

  public setPreviousStep(event) {
    let activeStep = this.whatStepIsActive - 1;
    this.setNewNextStep(activeStep);
  }

  public setNewNextStep(newStep: number) {
    if (newStep === 2) {
      this.skipEmployees = false;
    }
    if (newStep === 3) {
      this.skipBankInfo = false;
    }
    this.steps = this.steps
      .map((step: IStep) => {
        step.isActive = false;
        return step;
      })
      .map((step: IStep) => {
        if (step.stepNumber === newStep || step.stepNumber < newStep) {
          step.isActive = true;
        }
        return step;
      });
  }

  public goBack() {
    const token = LocalStorageService.instance.get(EStorageType.Token);
    token
      ? this.router.navigate(["company-home"])
      : this.router.navigate(["landing"]);
  }
  public async confirmForm() {
    this._store.dispatch(showLoadingAction({}));
    try {
      const token = LocalStorageService.instance.get(EStorageType.Token);
      let companyInfo;
      if (token) {
        companyInfo = await this.companyService.createCompany(
          this.formGeneralInfoData()
        );
      } else {
        companyInfo = await this.companyService.createFirstCompany(
          this.formGeneralInfoData()
        );
      }

      // send new coworking media data
      const companyId = companyInfo.id;

      const companyMedia = await this.companyService.uploadMediaToCompany(
        this.formMedia(),
        companyId
      );

      if (!this.skipEmployees) {
        const employeesToCompany =
          await this.companyService.createEmployeesToCompany(
            this.registerForm.get("employeesForm").value,
            companyId
          );
      }
      if (!this.skipBankInfo) {
        // formBankData
        const formToCompany = await this.companyService.addBankInfo(
          this.formBankData(),
          companyId
        );
      }
      let activeStep = this.whatStepIsActive + 1;
      this.setNewNextStep(activeStep);

      if (token) {
        CompanyService.instance.newCompanyAdded.next(companyId);
      }
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message:
              e.status === 401
                ? this.translate.instant("general.expired")
                : e.data.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }
  get isInitStep() {
    return this.whatStepIsActive === 1 ? true : false;
  }
  get isLastStep() {
    return this.whatStepIsActive === this.steps.length ? true : false;
  }
  get whatStepIsActive() {
    let lastIndex = 0;
    this.steps.map((step, i) => {
      if (step.isActive) lastIndex = i;
    });
    return this.steps[lastIndex].stepNumber;
  }

  get whatFormIsActive() {
    const activeStep = this.whatStepIsActive;
    if (activeStep === 1) {
      return "generalForm";
    } else if (activeStep === 2) {
      return "employeesForm";
    } else if (activeStep === 3) {
      return "spacesForm";
    } else if (activeStep === 4) {
      return "servicesForm";
    } else if (activeStep === 5) {
      return this.registerForm.get("paymethodsForm").dirty
        ? "paymethodsForm"
        : "cardForm";
    }
  }

  get skipDisabled() {
    return this.registerForm.get("employeesForm").value.length > 0;
  }
  get isDisabledNextStep() {
    const formName = this.whatFormIsActive;
    if (this.whatStepIsActive === 2) {
      return (
        this.registerForm.get("employeesForm").value.length === 0 &&
        this.registerForm.get("employeesForm").valid
      );
    } else if (this.whatStepIsActive !== 6) {
      return this.registerForm.get(formName).invalid;
    } else {
      return false;
    }
  }
}
